var store = require("store");

//　トップページでアニメーション再生するか判断
var isMenuPage = "menu" == location.pathname.split("/")[1];
// var pathname = function() {
//   return location.pathname == "/menu/" ? "/" : location.pathname;
// };

if (isMenuPage) {
  // ==================================================
  // 外部からこのサイトを訪問したユーザーには必ずアニメーションを見せる
  // いちどアニメーションを見せたらサイト内部を回遊している間はアニメーションを見せない
  // ※トップページでリロードした場合は、アニメーションを見せる
  // ==================================================
  var fromOutside = !document.referrer.match(location.host);

  if (fromOutside) {
    store.set("referrer", location.pathname);
  }

  if (window.performance) {
    if (performance.navigation.type !== 1) {
      $("body").data("animate", true);
    }
  }
}

if ($(".campaign-unit-modal").length) {
  $(".campaign-unit-modal__close").click(function() {
    $(".campaign-unit-modal").fadeOut("fast");
  });
}

if ($("body").data("animate")) {
  //トップページに記述する
  // console.log("メニューです");
  //実行したいものを書く
} else {
  // console.log("メニューじゃないです");
  $(".campaign-unit-modal").hide();
}

document.addEventListener("click", e => {
  if (!e.target.closest(".campaign-unit-modal__inner")) {
    $(".campaign-unit-modal").fadeOut("fast");
  }
});
